import debounce from 'lodash.debounce'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { MultiSelect } from 'primereact/multiselect'
import { AutoComplete } from 'primereact/autocomplete'
import { Tooltip } from 'primereact/tooltip'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'
import {
  selectCertDetailValues,
  selectCopyPartyInformation,
  selectModelDetailValues,
  selectValues,
  selectProdDetailValues,
  selectStandardValue,
  selectStandardOptions,
  selectModelList,
  selectSecondaryStandardOptions,
  selectSecondaryStandardValue,
  updateCertDetailsFormValues,
  updateIsCertNumberOnMaxlength,
  updateStandardOptions,
  updateHasExistingModels,
  updateProdDetailsModelList,
  updateProductOwner,
  updateStandardValues,
  updateModelList,
  updateProductCategoryStandards,
  updateHasCertificateProductStandard,
  updateSecondaryStandardOptions,
  updateSecondaryStandardValues,
  updateProductCategoryOptions,
  selectProductCategoryOptions,
  selectSelectedProductCategory,
  updateSelectedProductCategory,
  updateRecommendationStatus,
  selectRecommendationStatus,
  selectSkipCoDecisioning,
  selectIsCo,
  updateTempStandardOptions,
  selectTempStandardOptions,
  updateIsTempStandardOptionLoaded,
  selectIsTempStandardOptionsLoaded,
  updateTempSecondaryStandardOptions,
  selectTempSecondaryStandardOptions,
  selectHasIssueDate,
  selectCopyState,
  updateHasEmptyProductStandardRow,
  clearAssetDocuments,
  selectCertificateAction,
  selectSelectedServiceRequest,
  selectProductOwnerSearch,
  updateProductOwnerSearch,
} from '../../../../../../features/createCertificate/createCertificateSlice'
import CertificateListService from '../../../../../../services/CertificateListService'
import ControlledInput from '../../../../../../shared/controlled-input/ControlledInput'
import CustomDatePicker from '../../../../../../shared/custom-date-picker/CustomDatePicker'
import './DynamicFieldMultiple.scss'
import { appInsights } from '../../../../../../services/appInsights'
import { v4 as uuidv4 } from 'uuid'
import { SeverityLevel } from '@microsoft/applicationinsights-web'
import { uniqBy } from 'lodash'
import { parseDate } from '../../../../../../utils/helpers/date.helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDay, faPray } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { InputNumber } from 'primereact/inputnumber'
import numeral from 'numeral'
import { countDecimals } from '../../../../../../utils/helpers/number.helpers'
import getRenamedPanels from '../utils/getRenamedPanels'
import {
  getAttributeUniqueName,
  CertificateGroupEnum,
  CERTIFICATE_MARK_WITHOUT_IMAGE_COLUMNNS,
  CERTIFICATE_SCHEME,
  SUMMARY_MAX_LENGTH,
  SUMMARY_MAX_LENGTH_MESSAGE,
  CERTIFICATE_OWNER_REFERENCE,
} from '../../../../../../utils/constants/certificate.constants'
import { orderBy } from 'lodash'
import { getIsDynamicInputField } from '../utils/GetDynamicInputField'
import UsersAutoComplete from './users-auto-complete/UsersAutoComplete'
import Dropdown from '../../../../../../shared/components/dropdown/Dropdown'
import ToolTipField from '../../../../../../shared/components/tooltip-field/TooltipField'

const DynamicFieldMultiple = props => {
  const {
    field,
    showMultiSelectValuesTooltip,
    formValues,
    attributeFlatList,
    isRequired,
    setFormValidityMessages,
    setFormValues,
    fieldIndex,
    rowIndex,
    fieldType,
    selectedScheme,
    setIsShowNoStandard,
    isEditCert,
    isModifyCert,
    hasRevisions,
    isAutoGenerate,
    addDynamicField,
    certificateDetails,
    setDropdownRef,
    setProductOwnerFilter,
    isFieldDisabled,
    certifyFields,
    decisionFields,
    recommendFields,
    isFieldMounted,
    setIsFieldMounted,
    onFieldChange,
    listCacheValue,
    readOnly, // implemented only on list
    filterListener,
    setFilterListener,
    setCacheValues,
    validityMessage,
  } = props

  const logPrefix = `DynamicFieldMultiple - ${uuidv4()}`
  const attributeNames = {
    STANDARD: getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard'),
    SECONDARY_STANDARD: getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'secondaryStandard'
    ),
    CERTIFICATIONPRODUCTTYPE: getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'certificationProductType'
    ),
    RECOMMENDATION_STATUS: getAttributeUniqueName(
      CertificateGroupEnum.Recommendation,
      'recommendationStatus'
    ),
    WATER_EFFICIENCY_RATING: getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'waterEfficiencyRating'
    ),
    ISSUE_DATE: getAttributeUniqueName(CertificateGroupEnum.Certify, 'issueDate'),
    MARK: getAttributeUniqueName(CertificateGroupEnum.Certificate, 'mark'),
    PRODUCTION_SITE: getAttributeUniqueName(CertificateGroupEnum.PartyType, 'productionSite'),
    LOCAL_REPRESENTATIVE: getAttributeUniqueName(
      CertificateGroupEnum.PartyType,
      'localRepresentative'
    ),
    APPLICANT: getAttributeUniqueName(CertificateGroupEnum.PartyType, 'applicant'),
    EXPIRY_DATE: getAttributeUniqueName(CertificateGroupEnum.Certify, 'expiryDate'),
    CERTIFICATE_TYPE: getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateType'),
    CERTIFICATE_SUMMARY_OF_MODIFICATIONS: getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'summaryofModifications'
    ),
    WITHDRAWAL_DATE: getAttributeUniqueName(CertificateGroupEnum.Certify, 'withdrawalDate'),
  }

  const isDynamicInputField =
    getIsDynamicInputField(selectedScheme, field.attribute_unique_name) ?? false

  const [dropdownWithSearch, setDropdownWithSearch] = useState([])
  const [dropdownWithSearchStandard, setDropdownWithSearchStandard] = useState([])
  const [origDropdownWithSearch, setOrigDropdownWithSearch] = useState()
  const [isDisabled, setIsDisabled] = useState(false)
  const [dynamicFieldValue, setDynamicFieldValue] = useState('')
  const [selectedDate, setSelectedDate] = useState(null)
  const [filterTextValue, setFilterTextValue] = useState('')
  const [isIpAttributesDropdownListLoading, setisIpAttributesDropdownListLoading] = useState(false)
  const [filtered, setFiltered] = useState([])
  const [standardPlaceholder, setStandardPlaceholder] = useState('')
  const [isTextAreaScrollable, setIsTextAreaScrollable] = useState(false)
  const dropdownRef = useRef()
  const isMounted = useRef(false)
  const textareaRef = useRef()
  const tooltipTargetRef = useRef(null)
  const dispatch = useDispatch()
  const projectDetailsValues = useSelector(selectValues)
  const modelDetailsValues = useSelector(selectModelDetailValues)
  const certDetailsValues = useSelector(selectCertDetailValues)
  const copyPartyInformation = useSelector(selectCopyPartyInformation)
  const productDetails = useSelector(selectProdDetailValues)
  const standardValue = useSelector(
    field.attribute_unique_name === attributeNames.STANDARD
      ? selectStandardValue
      : selectSecondaryStandardValue
  )
  const standardOptions = useSelector(
    field.attribute_unique_name === attributeNames.STANDARD
      ? selectStandardOptions
      : selectSecondaryStandardOptions
  )
  const temporaryStandardOptions = useSelector(selectTempStandardOptions)
  const tempSecondaryStandardOptions = useSelector(selectTempSecondaryStandardOptions)
  const modelList = useSelector(selectModelList)
  const productCategoryOptions = useSelector(selectProductCategoryOptions)
  const selectedProductTypeCode = useSelector(selectSelectedProductCategory)
  const recommendationStatus = useSelector(selectRecommendationStatus)
  const skipCoDecisioning = useSelector(selectSkipCoDecisioning)
  const isCo = useSelector(selectIsCo)
  const isTempStandardOptionsLoaded = useSelector(selectIsTempStandardOptionsLoaded)
  const [summaryValidityMessage, setSummaryValidityMessage] = useState('')
  const [fieldValidityMessage, setFieldValidityMessage] = useState('')
  const hasOriginalIssueDate = useSelector(selectHasIssueDate)
  const projectDetailsValuesPsn =
    projectDetailsValues.selectedProjectDetails &&
      projectDetailsValues.selectedProjectDetails?.partySiteNumber
      ? projectDetailsValues.selectedProjectDetails?.partySiteNumber
      : ''
  const copyState = useSelector(selectCopyState)
  const certificateAction = useSelector(selectCertificateAction)
  const selectedServiceRequest = useSelector(selectSelectedServiceRequest)

  const modelDetailsValuesPsn = modelDetailsValues?.partySiteNumber
    ? modelDetailsValues?.partySiteNumber
    : null

  const listCertifyAttributes = certifyFields
  const listDecisionAttributes = decisionFields
  const listRecommendAttributes = recommendFields

  const isOwnerReferenceField =
    field.attribute_unique_name ===
    getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')

  const isCreateCertificate = !isEditCert && !isModifyCert

  const isProjectHandlerOrReviewerField =
    field.attribute_name === 'projectHandlername' ||
    field.attribute_name === 'approver_Reviewername'

  const productOwnerSearch = useSelector(selectProductOwnerSearch)

  useEffect(() => {
    if (field.attribute_name === 'ownerReference' && !!productOwnerSearch) {
      setisIpAttributesDropdownListLoading(true)

      CertificateListService.getIpAttributesDropdownList(
        field.attribute_name,
        productOwnerSearch
      ).then(result => {
        if (result) {
          setDropdownWithSearch(result)
        } else {
          setisIpAttributesDropdownListLoading(false) // No content
        }
      })
    }

    dispatch(updateProductOwnerSearch(''))
  }, [productOwnerSearch])

  useEffect(() => {
    const semicolonToken = 'cannot contain Semicolon'
    const targetIndex = fieldType === 'table' ? rowIndex : fieldIndex
    const semicolonMessage = `${field.display_name} attribute's value cannot contain Semicolon.`

    if (
      field.attribute_unique_name === attributeNames.CERTIFICATE_SUMMARY_OF_MODIFICATIONS &&
      Array.isArray(validityMessage)
    ) {
      const message = validityMessage[targetIndex] ?? ''
      setSummaryValidityMessage(
        typeof message === 'string' && message.includes(semicolonToken) ? '' : message
      )
    } else {
      setSummaryValidityMessage('')
    }

    // Set field validity message only for semicolon validation errors.
    // For summary fields, max-length can temporarily replace row-level validity text,
    // so fall back to current value-based detection to keep semicolon feedback visible.
    const fieldMessageFromArray = Array.isArray(validityMessage) ? validityMessage[targetIndex] : ''
    const fieldValue = formValues?.[field.attribute_unique_name]
    const semicolonFromValue = Array.isArray(fieldValue)
      ? typeof fieldValue[targetIndex] === 'string' && fieldValue[targetIndex].includes(';')
      : typeof fieldValue === 'string' && fieldValue.includes(';')

    if (
      typeof validityMessage === 'string' &&
      validityMessage.includes(semicolonToken)
    ) {
      setFieldValidityMessage(validityMessage)
    } else if (
      typeof fieldMessageFromArray === 'string' &&
      fieldMessageFromArray.includes(semicolonToken)
    ) {
      setFieldValidityMessage(fieldMessageFromArray)
    } else if (semicolonFromValue) {
      setFieldValidityMessage(semicolonMessage)
    } else {
      setFieldValidityMessage('')
    }
  }, [field, formValues, validityMessage, fieldIndex, rowIndex, fieldType])

  useEffect(() => {
    if (
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
    ) {
      setDropdownRef(dropdownRef)
    }

    if (
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ratingsBlob') ||
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ratings2Blob')
    ) {
      const el = document.getElementById(`certificate_${field.attribute_name}`)

      if (!el) return
      const shouldScroll = el.scrollHeight > 120
      setIsTextAreaScrollable(shouldScroll)
    }
  })
  useEffect(() => {
    if (isFormValuesObjectInValid(formValues)) return

    let newValue = ''
    if (fieldType === 'list' && !field.is_allow_search) {
      const tempList = formValues[field.attribute_unique_name]
      if (!tempList) return

      newValue = tempList[fieldIndex] ? tempList[fieldIndex] : ''
    } else if (fieldType === 'list' && field.is_allow_search) {
      const tempList = formValues[field.attribute_unique_name]
      if (!tempList) return

      newValue = tempList[fieldIndex] ? tempList[fieldIndex] : ''
    } else if (fieldType === 'table') {
      if (
        field.data_type.toLowerCase() === 'date' &&
        !Array.isArray(formValues[field.attribute_unique_name])
      ) {
        newValue = formValues[field.attribute_unique_name]
          ? formValues[field.attribute_unique_name]
          : ''
      } else {
        const tempTable = formValues[field.attribute_unique_name]
        if (!tempTable) return

        newValue = Array.isArray(tempTable)
          ? tempTable[rowIndex]
            ? tempTable[rowIndex]
            : ''
          : tempTable
      }
    } else if (fieldType === 'single' || fieldType === 'selectmultiple') {
      newValue = formValues[field.attribute_unique_name]
        ? formValues[field.attribute_unique_name]
        : ''

      if (
        field.attribute_unique_name === attributeNames.MARK &&
        fieldType === 'single' &&
        !isEditCert
      ) {
        const maxValue = field.max_value
        if (maxValue === '1' && field.list_values.length === 1) {
          newValue = Array.isArray(formValues[field.attribute_unique_name])
            ? (formValues[field.attribute_unique_name][0] ?? field?.list_values[0])
            : (formValues[field.attribute_unique_name] ?? field?.list_values[0])
        }
      }
    }

    setDynamicFieldValue(newValue)

    if (field.data_type.toLowerCase() === 'date') {
      const parsedDate = parseDate(newValue)
      setSelectedDate(parsedDate ? parsedDate : null)
    }
  }, [
    fieldType,
    formValues,
    fieldIndex,
    field.attribute_unique_name,
    field.data_type,
    rowIndex,
    JSON.stringify(formValues[field.attribute_unique_name]),
  ])

  useEffect(async () => {
    if (isFormValuesObjectInValid(formValues)) return

    if (
      field.attribute_unique_name != attributeNames.STANDARD &&
      field.attribute_unique_name != attributeNames.SECONDARY_STANDARD
    )
      return

    if (!certDetailsValues.standardOptions) {
      const prodCategory =
        formValues[
        getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificationProductType')
        ]
      const standards = formValues[field.attribute_unique_name]

      if (attributeFlatList && prodCategory) {
        if (isEditCert || isModifyCert || copyState.certificateScheme)
          await handleStandardDetails(standards, prodCategory)
        await handleGetStandardList(prodCategory, field.attribute_unique_name)
      }
    } else if (
      certDetailsValues.standardOptions &&
      field.attribute_unique_name === attributeNames.STANDARD &&
      dropdownWithSearchStandard.length === 0
    ) {
      dispatch(updateStandardOptions(certDetailsValues.standardOptions))
      setDropdownWithSearchStandard(certDetailsValues.standardOptions)
    }
  }, [dispatch, formValues])

  useEffect(async () => {
    if (isFormValuesObjectInValid(formValues)) return
    let search = selectedScheme
    if (
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificationProductType') &&
      search &&
      (!dropdownWithSearch || dropdownWithSearch.length === 0) &&
      !filterTextValue
    ) {
      dispatch(updateSelectedProductCategory(null))
      dispatch(updateProductCategoryOptions(null))

      await CertificateListService.getIpAttributesDropdownList(field.attribute_name, search).then(
        result => {
          setDropdownWithSearch(result)
          if (formValues[field.attribute_unique_name]) {
            setDynamicFieldValue(formValues[field.attribute_unique_name])
          }

          dispatch(updateProductCategoryOptions(result))
        }
      )
    } else if (field.attribute_unique_name === attributeNames.RECOMMENDATION_STATUS) {
      const status = formValues[field.attribute_unique_name]

      let isRecommended = true
      if ((status === 'None' || status === 'Do Not Recommend') && selectedScheme)
        isRecommended = false

      dispatch(updateRecommendationStatus(isRecommended))
    }
  }, [
    field.attribute_unique_name,
    selectedScheme,
    filterTextValue,
    formValues,
    dropdownWithSearch,
    setIsShowNoStandard,
  ])

  useEffect(() => {
    setisIpAttributesDropdownListLoading(false)
  }, [dropdownWithSearch])

  useEffect(() => {
    if (field.attribute_unique_name === attributeNames.MARK) {
      const certificateMark = formValues[field.attribute_unique_name]
      const certScheme = formValues[attributeNames.CERTIFICATE_TYPE]?.toLocaleLowerCase()
      const withoutImageColumns = CERTIFICATE_MARK_WITHOUT_IMAGE_COLUMNNS.includes(
        certificateMark?.toLocaleLowerCase() ?? ''
      )

      if (
        certScheme === CERTIFICATE_SCHEME.ANZ_CERTIFICATION_SCHEME.toLocaleLowerCase() &&
        withoutImageColumns
      ) {
        dispatch(clearAssetDocuments())
      }
    }
  }, [formValues])

  useEffect(() => {
    if (
      !certDetailsValues.standardOptions &&
      field.attribute_unique_name === attributeNames.STANDARD
    ) {
      setDropdownWithSearch(certDetailsValues.standardOptions)
    }
  }, [certDetailsValues.standardOptions])

  const isCopyingPartyInformation = copyPartyInformation && field.type_identity === 'B_PARTY TYPE'

  useEffect(async () => {
    if ((!dropdownWithSearch || dropdownWithSearch.length === 0) && !filterTextValue) {
      if (
        field.is_allow_search &&
        (modelDetailsValuesPsn || projectDetailsValuesPsn || isCopyingPartyInformation)
      ) {
        let defaultSelected

        if ((isEditCert || isCopyingPartyInformation) && dynamicFieldValue) {
          defaultSelected = dynamicFieldValue
        }

        if (
          !isEditCert &&
          !isCopyingPartyInformation &&
          !addDynamicField &&
          (modelDetailsValuesPsn || projectDetailsValuesPsn)
        ) {
          defaultSelected =
            field.attribute_unique_name ===
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
              ? (modelDetailsValuesPsn ?? projectDetailsValuesPsn)
              : projectDetailsValuesPsn
        }

        if (
          isEditCert &&
          (field.attribute_unique_name === attributeNames.PRODUCTION_SITE ||
            field.attribute_unique_name === attributeNames.LOCAL_REPRESENTATIVE ||
            field.attribute_unique_name === attributeNames.APPLICANT ||
            field.attribute_unique_name ===
            getAttributeUniqueName(CertificateGroupEnum.PartyType, 'brandOwner')) &&
          !defaultSelected
        ) {
          if (fieldType === 'list') {
            defaultSelected = formValues[field.attribute_unique_name][fieldIndex]
              ? formValues[field.attribute_unique_name][fieldIndex]
              : formValues[
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
              ]
          } else {
            defaultSelected = formValues[field.attribute_unique_name]
              ? formValues[field.attribute_unique_name]
              : formValues[
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
              ]
          }
        }

        if (!defaultSelected) return
        const srcSelectedValue = Array.isArray(formValues[field.attribute_unique_name])
          ? formValues[field.attribute_unique_name][fieldIndex]
          : null

        await CertificateListService.getIpAttributesDropdownList(
          field.attribute_name,
          defaultSelected
        ).then(result => {
          if (result && result.length > 0) {
            setDropdownWithSearch(result)

            if (onFieldChange && Boolean(srcSelectedValue)) {
              // cache selected value for edit
              onFieldChange(result.find(item => item.code === srcSelectedValue))
            }

            if (!filterTextValue && !origDropdownWithSearch) {
              setOrigDropdownWithSearch(result)
            }

            if (
              field.attribute_unique_name ===
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference') ||
              field.attribute_unique_name === attributeNames.APPLICANT
            ) {
              setDynamicFieldValue(defaultSelected)
              setFormValues(prevState => {
                const newState = {
                  ...prevState,
                  [field.attribute_unique_name]: defaultSelected,
                }

                dispatch(updateCertDetailsFormValues(newState))
                return newState
              })

              setFormValidityMessages(prevState => {
                let newState = JSON.parse(JSON.stringify(prevState))
                newState[field.attribute_unique_name] = ''
                return newState
              })
            }
          } else {
            appInsights?.trackTrace({
              message: `${logPrefix} - CertificateListService.getIpAttributesDropdownList - 'No data with given parameter ${field.attribute_unique_name} / ${defaultSelected}'}`,
              severityLevel: SeverityLevel.Error,
            })
          }
        })
      }
      //If no partysitenumber, get the value from cerfiticate details from cert attribute api level
      //we will get the values from cert edit level
      //only with 4 properties mentioned below
      else {
        if (
          field.attribute_unique_name ===
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference') ||
          field.attribute_unique_name === attributeNames.APPLICANT ||
          field.attribute_unique_name === attributeNames.LOCAL_REPRESENTATIVE ||
          field.attribute_unique_name ===
          getAttributeUniqueName(CertificateGroupEnum.PartyType, 'brandOwner')
        ) {
          const defaultSelected = certDetailsValues.formValues[field.attribute_unique_name]

          if (defaultSelected === null) return

          await CertificateListService.getIpAttributesDropdownList(
            field.attribute_name,
            defaultSelected
          ).then(result => {
            if (result && result.length > 0) {
              setDropdownWithSearch(result)

              if (!filterTextValue && !origDropdownWithSearch) {
                setOrigDropdownWithSearch(result)
              }
              setDynamicFieldValue(defaultSelected)
              setFormValues(prevState => {
                const newState = {
                  ...prevState,
                  [field.attribute_unique_name]: defaultSelected,
                }

                dispatch(updateCertDetailsFormValues(newState))
                return newState
              })

              setFormValidityMessages(prevState => {
                let newState = JSON.parse(JSON.stringify(prevState))
                newState[field.attribute_unique_name] = ''
                return newState
              })
            } else {
              appInsights?.trackTrace({
                message: `${logPrefix} - CertificateListService.getIpAttributesDropdownList - 'No data with given parameter ${field.attribute_unique_name} / ${defaultSelected}'}`,
                severityLevel: SeverityLevel.Error,
              })
            }
          })
        }

        // const certificateAttribute = certDetailsValues.attributeFlatList(
        //   (x) => x.attribute_unique_name == field.attribute_unique_name
        // );

        // if (!certificateAttribute) return;
      }
    }
  }, [
    field.attribute_unique_name,
    field.is_allow_search,
    filterTextValue,
    origDropdownWithSearch,
    setFormValues,
    dropdownWithSearch,
    setFormValidityMessages,
    modelDetailsValues,
    projectDetailsValues,
    dynamicFieldValue,
    isEditCert,
    dispatch,
  ])

  useEffect(async () => {
    if ((!dropdownWithSearch || dropdownWithSearch.length === 0) && !filterTextValue) {
      if (
        field.is_allow_search &&
        (modelDetailsValuesPsn || projectDetailsValuesPsn || isCopyingPartyInformation)
      ) {
        let defaultSelected
        if (addDynamicField && (projectDetailsValuesPsn || modelDetailsValuesPsn)) {
          defaultSelected =
            field.attribute_unique_name ===
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
              ? (modelDetailsValuesPsn ?? projectDetailsValuesPsn)
              : projectDetailsValuesPsn
        }

        if (!defaultSelected) return

        await CertificateListService.getIpAttributesDropdownList(
          field.attribute_name,
          defaultSelected
        ).then(result => {
          if (result && result.length > 0) {
            setDropdownWithSearch(result)

            if (!filterTextValue && !origDropdownWithSearch) {
              setOrigDropdownWithSearch(result)
            }

            if (
              field.attribute_unique_name ===
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference') ||
              field.attribute_unique_name === attributeNames.APPLICANT
            ) {
              setDynamicFieldValue(defaultSelected)
              setFormValues(prevState => {
                const newState = {
                  ...prevState,
                  [field.attribute_unique_name]: defaultSelected,
                }

                dispatch(updateCertDetailsFormValues(newState))
                return newState
              })

              setFormValidityMessages(prevState => {
                let newState = JSON.parse(JSON.stringify(prevState))
                newState[field.attribute_unique_name] = ''
                return newState
              })
            }
          } else {
            appInsights?.trackTrace({
              message: `${logPrefix} - CertificateListService.getIpAttributesDropdownList - 'No data with given parameter ${field.attribute_unique_name} / ${defaultSelected}'}`,
              severityLevel: SeverityLevel.Error,
            })
          }
        })
      }
    }
  }, [addDynamicField])

  useEffect(() => {
    const { formValues } = certDetailsValues
    if (
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
    ) {
      setFormValues(formValues)
    }
  }, [
    certDetailsValues.formValues?.[
    getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
    ],
  ])

  useEffect(() => {
    if (!isMounted.current) return
    if (!listCertifyAttributes.includes(field.attribute_unique_name)) return
    if (
      (field.attribute_unique_name === attributeNames.ISSUE_DATE &&
        hasOriginalIssueDate &&
        isCertificateFromRevision()) ||
      field.attribute_unique_name === attributeNames.EXPIRY_DATE
    )
      return

    const isArrayType = Array.isArray(formValues[field.attribute_unique_name])
    let defaultValue = ''

    if (!recommendationStatus && isArrayType) defaultValue = []
    else {
      const attribute = certDetailsValues?.flatAttributeList?.find(
        data => data.attribute_unique_name === field.attribute_unique_name
      )

      if (isArrayType) defaultValue = [attribute.default_value]
      else defaultValue = attribute.default_value
    }

    if (field.is_required && (!defaultValue || defaultValue[0] === '')) {
      setFormValidityMessages(prevState => {
        const newState = {
          ...prevState,
          [field.attribute_unique_name]: `${field.attribute_unique_name} is required.`,
        }

        return newState
      })
    }

    setFormValues(prevState => {
      const newState = {
        ...prevState,
        [field.attribute_unique_name]: defaultValue,
      }

      dispatch(updateCertDetailsFormValues(newState))
      return newState
    })
  }, [recommendationStatus])

  useEffect(() => {
    if (isMounted.current) return
    isMounted.current = true
  }, [])

  useEffect(() => {
    if (!isMounted.current) return

    if (!isModifyCert) return

    if (!isCo) return

    if (isFieldMounted) return

    const decisionSet = new Set(listDecisionAttributes)
    const recommendSet = new Set(listRecommendAttributes)
    const certifySet = new Set(listCertifyAttributes)

    if (
      !(
        decisionSet.has(field.attribute_unique_name) ||
        recommendSet.has(field.attribute_unique_name) ||
        certifySet.has(field.attribute_unique_name)
      )
    )
      return

    if (
      field.attribute_unique_name === attributeNames.ISSUE_DATE ||
      field.attribute_unique_name === attributeNames.EXPIRY_DATE ||
      (field.attribute_unique_name === attributeNames.WITHDRAWAL_DATE &&
        certificateAction.isWithdraw)
    )
      return

    if (isFormValuesObjectInValid(formValues)) return

    const isArrayType = Array.isArray(formValues[field.attribute_unique_name])
    let defaultValue = ''

    const attribute = certDetailsValues?.flatAttributeList?.find(
      data => data.attribute_unique_name === field.attribute_unique_name
    )

    if (isArrayType) defaultValue = [attribute.default_value]
    else defaultValue = attribute.default_value

    if (attribute.is_required && (!defaultValue || defaultValue[0] === '')) {
      setFormValidityMessages(prevState => {
        const newState = {
          ...prevState,
          [field.attribute_unique_name]: `${field.attribute_unique_name} is required.`,
        }

        return newState
      })
    }

    setFormValues(prevState => {
      const newState = {
        ...prevState,
        [field.attribute_unique_name]: defaultValue,
      }
      dispatch(updateCertDetailsFormValues(newState))
      return newState
    })
  }, [])

  useEffect(() => {
    if (isTempStandardOptionsLoaded) return

    if (
      (isModifyCert || isEditCert) &&
      field.attribute_unique_name === attributeNames.STANDARD &&
      !isTempStandardOptionsLoaded
    ) {
      dispatch(updateTempStandardOptions(standardOptions))
    }
  }, [standardOptions])

  useEffect(() => {
    if (
      field.attribute_unique_name === attributeNames.CERTIFICATIONPRODUCTTYPE &&
      (isModifyCert || isEditCert)
    ) {
      const productType = formValues[attributeNames.CERTIFICATIONPRODUCTTYPE]
      const schemeScope = productCategoryOptions?.find(o => o.code === productType)

      if (schemeScope != null)
        dispatch(updateSelectedProductCategory(schemeScope.otherProps.schemeScopeCode))
    }
  }, [productCategoryOptions])

  const getStandards = useCallback(async () => {
    const prodCategory =
      formValues[
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificationProductType')
      ]
    if (
      prodCategory &&
      (field.attribute_unique_name === attributeNames.STANDARD ||
        field.attribute_unique_name === attributeNames.SECONDARY_STANDARD)
    ) {
      await handleGetStandardList(prodCategory, field.attribute_unique_name)
    }
  }, [])

  useEffect(() => {
    getStandards()
  }, [])

  useEffect(() => {
    if (!isMounted.current) return
    setIsFieldMounted(true)
  }, [])

  useEffect(() => {
    if (isOwnerReferenceField && isCreateCertificate) {
      setDropdownWithSearch([])
      const newFormValues = {
        ...formValues,
        [CERTIFICATE_OWNER_REFERENCE]: null,
      }
      dispatch(updateCertDetailsFormValues(newFormValues))
    }
  }, [selectedServiceRequest])

  const onFilterDropdownWithSearch = async function (e) {
    setFilterTextValue(e.filter)

    if (
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
    )
      setProductOwnerFilter(e.filter)

    if (e.filter) {
      await CertificateListService.getIpAttributesDropdownList(field.attribute_name, e.filter).then(
        result => {
          if (result) {
            // result = result.length === 0 ? [" "] : result;
            setDropdownWithSearch(result)
          } else {
            setisIpAttributesDropdownListLoading(false) // No content
          }
        }
      )
    } else {
      setDropdownWithSearch(origDropdownWithSearch)
    }
  }

  const isCertificateFromRevision = () => {
    return isEditCert && (hasRevisions || isModifyCert)
  }
  const handleStandardDetails = async (standardIds, prodCategory) => {
    standardIds.forEach(standardId => {
      CertificateListService.getIpStandardDetails('standard', standardId).then(result => {
        if (result?.length > 0) {
          setDropdownWithSearchStandard(prevState => {
            if (!prevState?.some(state => state.code === result[0].code)) {
              const newState = prevState ? prevState.concat(result[0]) : result
              dispatch(updateStandardOptions(newState))
              return newState
            }

            return prevState
          })
        } else {
          setIsDisabled(true)

          if (prodCategory && field.attribute_unique_name === attributeNames.STANDARD) {
            setIsShowNoStandard({
              isShow: true,
              message: 'No Standard is/are available for the selected Product Category',
            })
          }
        }
      })

      setIsDisabled(false)
    })

    dispatch(updateStandardValues(standardIds))
  }

  const isArrayNotValidOrEmpty = array =>
    !Boolean(array) || (Array.isArray(array) && array.length <= 0)
  const handleProductCategoryChange = async prodCategory => {
    const [standardResult, secondaryStandardResult] = await Promise.all([
      CertificateListService.getIpAttributesDropdownList('standard', prodCategory),
      CertificateListService.getIpAttributesDropdownList('secondaryStandard', prodCategory),
    ])
    const isStandardInvalid = isArrayNotValidOrEmpty(standardResult)

    try {
      if (isStandardInvalid) {
        setIsDisabled(true)
        if (prodCategory) {
          setIsShowNoStandard({
            isShow: true,
            message: 'No Standard is/are available for the selected Product Category',
          })
        }
        dispatch(updateHasCertificateProductStandard(false))
        return
      }

      if (!isEditCert && !isModifyCert) return

      dispatch(updateProductCategoryStandards(standardResult))
      dispatch(updateHasCertificateProductStandard(true))
      setIsDisabled(false)
    } finally {
      dispatch(updateIsTempStandardOptionLoaded(true))
      dispatch(
        updateModelList(
          structuredClone(modelList ?? []).map(item => {
            item.productStandards = []
            return item
          })
        )
      )
      dispatch(updateStandardOptions(standardResult ?? []))
      dispatch(updateSecondaryStandardOptions(secondaryStandardResult ?? []))
    }
  }

  const handleGetStandardList = async (prodCategory, fieldname) => {
    const standardAndSecondaryApiPayload = getStandardAndSecondaryStandards(fieldname)

    CertificateListService.getIpAttributesDropdownList(
      standardAndSecondaryApiPayload,
      prodCategory
    ).then(result => {
      if (!result || result?.length === 0) {
        setIsDisabled(true)
        if (prodCategory && field.attribute_unique_name === attributeNames.STANDARD) {
          setIsShowNoStandard({
            isShow: true,
            message: 'No Standard is/are available for the selected Product Category',
          })
        } else if (field.attribute_unique_name === attributeNames.SECONDARY_STANDARD) {
          setStandardPlaceholder(`None available for ${selectedProductTypeCode}`)
        }
        return
      }

      if (fieldname === attributeNames.STANDARD) {
        if (isEditCert || isModifyCert || copyState.certificateScheme) {
          setDropdownWithSearchStandard(prevState => {
            let newState = []

            if (prevState?.length > 0) {
              newState = uniqBy([...prevState, ...result], option => option.code)
            } else {
              newState = result
            }

            newState = orderBy(newState, ['name'], ['asc'])

            dispatch(updateStandardOptions(newState))
            dispatch(updateProductCategoryStandards(newState))
            return newState
          })

          dispatch(updateStandardValues(formValues[fieldname]))
        } else {
          let list = orderBy(result, ['name'], ['asc'])
          dispatch(updateStandardOptions(list))
        }
      } else if (fieldname === attributeNames.SECONDARY_STANDARD) {
        // setStandardPlaceholder("");
        if (isEditCert || isModifyCert || copyState.certificateScheme) {
          setDropdownWithSearchStandard(prevState => {
            let newState = []

            if (prevState?.length > 0) {
              newState = uniqBy([...prevState, ...result], option => option.code)
            } else {
              newState = result
            }

            newState = orderBy(newState, ['name'], ['asc'])
            dispatch(updateSecondaryStandardOptions(newState))
            dispatch(updateTempSecondaryStandardOptions(newState))
            return newState
          })

          dispatch(updateSecondaryStandardValues(formValues[fieldname]))
        } else {
          let list = orderBy(result, ['name'], ['asc'])

          dispatch(updateSecondaryStandardOptions(list))
          dispatch(updateTempSecondaryStandardOptions(list))

          if (result.length === 1) {
            const defaultValue = result.map(standard => standard.code)
            dispatch(updateSecondaryStandardValues(defaultValue))

            setFormValues(prevState => {
              const newState = {
                ...prevState,
                [attributeNames.SECONDARY_STANDARD]: defaultValue,
              }

              dispatch(updateCertDetailsFormValues(newState))
              return newState
            })
          }
        }
      }

      setIsDisabled(false)
    })
  }

  const getStandardAndSecondaryStandards = attribute_unique_name => {
    let apiParameter

    switch (attribute_unique_name) {
      case attributeNames.STANDARD:
        apiParameter = 'standard'
        break
      case attributeNames.SECONDARY_STANDARD:
        apiParameter = 'secondaryStandard'
        break
      default:
        apiParameter = 'standard'
        break
    }

    return apiParameter
  }

  const setFieldValueToBlank = () => {
    setFormValues(prevState => {
      const newState = getNewFormValueByInput(prevState, '')
      checkFieldValidity(newState)

      dispatch(updateCertDetailsFormValues(newState))
      return newState
    })
  }

  const isTextInputField = () => {
    const dataType = field.data_type?.toLowerCase()
    const isListValues =
      field.list_values && Array.isArray(field.list_values) && field.list_values.length > 0

    if (dataType === 'date' || dataType === 'decimal' || dataType === 'integer') {
      return false
    }

    if (dataType === 'text') {
      if (isListValues) return false
      if (field.is_allow_search) return false
      if (field.is_search) return false
      if (field.is_select_multiple) return false
      return true
    }

    if (dataType === 'textarea') {
      return true
    }

    return false
  }

  const getSemicolonValidityMessage = (newFormValuesState, newFormValidityMessagesState) => {
    if (!isTextInputField() && !isDynamicInputField) {
      return newFormValidityMessagesState
    }

    const fieldValue = newFormValuesState[field.attribute_unique_name]
    const semicolonMessage = `${field.display_name} attribute's value cannot contain Semicolon.`

    if (Array.isArray(fieldValue)) {
      const currentMessages = Array.isArray(newFormValidityMessagesState[field.attribute_unique_name])
        ? [...newFormValidityMessagesState[field.attribute_unique_name]]
        : []
      const maxLength = Math.max(fieldValue.length, currentMessages.length)

      for (let index = 0; index < maxLength; index += 1) {
        const hasSemicolon =
          typeof fieldValue[index] === 'string' && fieldValue[index].includes(';')
        const currentMessage = currentMessages[index]

        if (hasSemicolon) {
          currentMessages[index] = semicolonMessage
        } else if (
          typeof currentMessage === 'string' &&
          currentMessage.includes('cannot contain Semicolon')
        ) {
          currentMessages[index] = ''
        }
      }

      newFormValidityMessagesState[field.attribute_unique_name] = currentMessages
      return newFormValidityMessagesState
    }

    if (typeof fieldValue === 'string' && fieldValue.includes(';')) {
      newFormValidityMessagesState[field.attribute_unique_name] = semicolonMessage
    } else {
      const currentMessage = newFormValidityMessagesState[field.attribute_unique_name]
      if (
        typeof currentMessage === 'string' &&
        currentMessage.includes('cannot contain Semicolon')
      ) {
        newFormValidityMessagesState[field.attribute_unique_name] = ''
      }
    }

    return newFormValidityMessagesState
  }

  const getRequiredValidityMessage = (newFormValuesState, newFormValidityMessagesState) => {
    let validityMessage = ''
    if (isRequired) {
      switch (fieldType) {
        case 'list':
        case 'table':
          if (Array.isArray(newFormValuesState[field.attribute_unique_name])) {
            const noDataItem = newFormValuesState[field.attribute_unique_name]
              ? newFormValuesState[field.attribute_unique_name].filter(
                item => !item || (typeof item === 'string' && item.trim().length === 0)
              )
              : null
            if (noDataItem && noDataItem.length > 0) {
              validityMessage = field.display_name + ' is required.'
            }
          }

          break
        case 'selectmultiple':
          if (
            newFormValuesState[field.attribute_unique_name] &&
            newFormValuesState[field.attribute_unique_name].length === 0
          ) {
            validityMessage = field.attribute_unique_name + ' is required.'
          }
          break
        default:
          if (
            !newFormValuesState[field.attribute_unique_name] ||
            (typeof newFormValuesState[field.attribute_unique_name] === 'string' &&
              newFormValuesState[field.attribute_unique_name].trim().length === 0)
          ) {
            validityMessage = field.attribute_unique_name + ' is required.'
          }
          break
      }
    }

    const existingFieldMessage = newFormValidityMessagesState[field.attribute_unique_name]
    const targetIndex = fieldType === 'table' ? rowIndex : fieldIndex

    if (Array.isArray(existingFieldMessage)) {
      // Keep row-level messages for list/table fields so edits in one row
      // do not clear messages in other rows.
      const nextMessages = [...existingFieldMessage]
      nextMessages[targetIndex] = validityMessage
      newFormValidityMessagesState[field.attribute_unique_name] = nextMessages
    } else {
      newFormValidityMessagesState[field.attribute_unique_name] = validityMessage
    }

    if (
      hasEnteredNotApplicable(
        newFormValuesState[
        getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName')
        ]
      )
    ) {
      newFormValidityMessagesState[
        getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName')
      ] = enteredNotApplicableErrorMessage
    }

    return newFormValidityMessagesState
  }

  const getMinMaxValidityMessage = (newFormValuesState, newFormValidityMessagesState) => {
    if (field.data_type !== 'decimal') return newFormValidityMessagesState
    const rawValue = newFormValuesState[field.attribute_unique_name]
    const value = numeral(rawValue).value()
    const min = numeral(field.range_low).value()
    const max = numeral(field.range_high).value()
    let validityMessage = null

    if (min === null || max === null || (!field.is_required && !Boolean(rawValue))) {
      validityMessage = ''
    } else if (value < min) {
      validityMessage = {
        value: `${field.display_name} attribute's value must be less than or equal to ${min}`,
        displayOnEffect: true,
      }
    } else if (value > max) {
      validityMessage = {
        value: `${field.display_name} attribute's value must be greater than or equal to ${max}`,
        displayOnEffect: true,
      }
    }

    if (validityMessage) newFormValidityMessagesState[field.attribute_unique_name] = validityMessage
    return newFormValidityMessagesState
  }

  const getDateValidityMessage = (newFormValuesState, newFormValidityMessagesState) => {
    if (field.data_type.toLowerCase() === 'date' && field.attribute_unique_name) {
      if (
        field.attribute_unique_name ===
        getAttributeUniqueName(CertificateGroupEnum.Certify, 'issueDate') ||
        field.attribute_unique_name ===
        getAttributeUniqueName(CertificateGroupEnum.Certify, 'expiryDate')
      ) {
        let expiryDateValue =
          newFormValuesState[getAttributeUniqueName(CertificateGroupEnum.Certify, 'expiryDate')]
        let issueDateValue =
          newFormValuesState[getAttributeUniqueName(CertificateGroupEnum.Certify, 'issueDate')]

        let expiryDate = new Date(expiryDateValue)
        let issueDate = new Date(issueDateValue)

        if (expiryDateValue && issueDateValue && issueDate.getTime() > expiryDate.getTime()) {
          newFormValidityMessagesState[
            getAttributeUniqueName(CertificateGroupEnum.Certify, 'issueDate')
          ] = ''
          newFormValidityMessagesState[
            getAttributeUniqueName(CertificateGroupEnum.Certify, 'expiryDate')
          ] = 'Expiry Date must be greater than or equal to Issue Date'
        }
      }
    }
    return newFormValidityMessagesState
  }

  const checkFieldValidity = (newFormValuesState, hasExceededLength) => {
    setFormValidityMessages(prevFormValidityMessagesState => {
      let newFormValidityMessagesState = JSON.parse(JSON.stringify(prevFormValidityMessagesState))
      const targetIndex = fieldType === 'table' ? rowIndex : fieldIndex
      newFormValidityMessagesState = getRequiredValidityMessage(
        newFormValuesState,
        newFormValidityMessagesState
      )
      newFormValidityMessagesState = getDateValidityMessage(
        newFormValuesState,
        newFormValidityMessagesState
      )
      newFormValidityMessagesState = getMinMaxValidityMessage(
        newFormValuesState,
        newFormValidityMessagesState
      )
      newFormValidityMessagesState = getSemicolonValidityMessage(
        newFormValuesState,
        newFormValidityMessagesState
      )

      if (field?.attribute_unique_name === attributeNames.CERTIFICATE_SUMMARY_OF_MODIFICATIONS) {
        const fieldName = field.attribute_unique_name

        if (!Array.isArray(newFormValidityMessagesState[fieldName])) {
          newFormValidityMessagesState[fieldName] = Array.isArray(
            prevFormValidityMessagesState[fieldName]
          )
            ? [...prevFormValidityMessagesState[fieldName]]
            : []
        }

        if (hasExceededLength) {
          newFormValidityMessagesState[field.attribute_unique_name][targetIndex] =
            SUMMARY_MAX_LENGTH_MESSAGE
        } else {
          const currentMessage =
            newFormValidityMessagesState[field.attribute_unique_name][targetIndex]
          if (currentMessage === SUMMARY_MAX_LENGTH_MESSAGE) {
            newFormValidityMessagesState[field.attribute_unique_name][targetIndex] = ''
          }
        }
      }

      return newFormValidityMessagesState
    })
  }

  const onChangeDate = date => {
    const formattedDate = date ? moment(date).format('YYYY-MM-DD') : null
    setSelectedDate(date)

    setFormValues(prevFieldState => {
      let newState = getNewFormValueByInput(prevFieldState, formattedDate)
      checkFieldValidity(newState)

      dispatch(updateCertDetailsFormValues(newState))
      return newState
    })
  }
  const processInteger = (field, e) => {
    if (field.data_type == 'integer' && e.target.value) {
      const newValue = filterIntegerCharacters(e.target.value)
      e.target.value = newValue
    }
  }
  const filterIntegerCharacters = input => {
    return input.replace(/\D/g, '')
  }
  const processDecimal = (field, e) => {
    if (field.data_type == 'decimal' && e.target.value) {
      const newValue = filterToSingleFloat(e.target.value)
      e.target.value = newValue
    }
  }
  const filterToSingleFloat = input => {
    let filtered = input.replace(/[^\d.]/g, '')
    const parts = filtered.split('.')
    return parts.length > 1
      ? parts[0] + '.' + parts.slice(1).join('') // keep first dot only
      : filtered
  }

  const onChangeDynamicInput = e => {
    processInteger(field, e)
    processDecimal(field, e)
    if (
      field.attribute_unique_name === attributeNames.CERTIFICATIONPRODUCTTYPE &&
      !isModifyCert &&
      !isEditCert
    ) {
      dispatch(updateStandardOptions(null))
      dispatch(updateStandardValues(null))
      dispatch(updateSecondaryStandardOptions(null))
      dispatch(updateSecondaryStandardValues(null))
      dispatch(updateSelectedProductCategory(null))
    }
    if (
      field.attribute_unique_name === attributeNames.CERTIFICATIONPRODUCTTYPE &&
      (isModifyCert || isEditCert)
    ) {
      handleProductCategoryChange(e.target.value)
    }

    if (field.attribute_unique_name === attributeNames.CERTIFICATIONPRODUCTTYPE) {
      if (!isModifyCert && !isEditCert) {
        setFormValues(prevState => {
          let newState = {
            ...prevState,
            [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard')]: [],
            [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'secondaryStandard')]: [],
          }

          dispatch(updateCertDetailsFormValues(newState))
          return newState
        })

        dispatch(updateHasEmptyProductStandardRow(true))
      }

      const schemeScope = productCategoryOptions?.find(o => o.code === e.target.value)

      if (schemeScope != null)
        dispatch(updateSelectedProductCategory(schemeScope.otherProps.schemeScopeCode))
    }

    if (field.attribute_unique_name === attributeNames.STANDARD && (!isModifyCert || !isEditCert)) {
      const maxValue = field.max_value
      if (maxValue != 'n') {
        if (e.target.value?.length > parseInt(maxValue))
          setIsShowNoStandard({
            isShow: true,
            message: 'Standard selection exceeds the maximum cardinality limit.',
          })
        else setIsShowNoStandard({ isShow: false, message: '' })
      }

      dispatch(updateStandardValues(e.target.value))
    }

    if (
      field.attribute_unique_name === attributeNames.SECONDARY_STANDARD &&
      (!isModifyCert || !isEditCert)
    ) {
      const maxValue = field.max_value
      if (maxValue != 'n') {
        if (e.target.value?.length > parseInt(maxValue))
          setIsShowNoStandard({
            isShow: true,
            message: 'Standard selection exceeds the maximum cardinality limit.',
          })
        else setIsShowNoStandard({ isShow: false, message: '' })
      }

      dispatch(updateSecondaryStandardValues(e.target.value))
    }

    if (
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName')
    ) {
      dispatch(updateIsCertNumberOnMaxlength(e.target.value.length > 150))
    }

    if (
      field.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
    ) {
      const { modelList } = productDetails

      if (modelList?.length > 0) {
        dispatch(updateHasExistingModels(true))
        dispatch(updateProductOwner(e.target.value))
        return
      }

      dispatch(updateHasExistingModels(false))
      dispatch(updateProdDetailsModelList([]))
    }

    if (field.attribute_unique_name === attributeNames.RECOMMENDATION_STATUS) {
      const status = e.target.value

      let isRecommended = true
      if (status === 'None' || status === 'Do Not Recommend') isRecommended = false

      dispatch(updateRecommendationStatus(isRecommended))
    }

    setFormValues(prevState => {
      let fieldValue = ''
      if (field.list_values && Array.isArray(field.list_values) && field.list_values.length > 0) {
        fieldValue = e.value
      } else {
        fieldValue = e.target?.value ?? e.value ?? ''
      }

      const originalEl = e.originalEvent?.target
      if (
        originalEl &&
        Boolean(originalEl?.classList) &&
        'contains' in originalEl?.classList &&
        (originalEl?.classList ?? []).contains('p-dropdown-clear-icon')
      ) {
        fieldValue = ''
      }

      let hasExceededLength = false

      if (field.attribute_unique_name === attributeNames.CERTIFICATE_SUMMARY_OF_MODIFICATIONS) {
        if (fieldValue.length > SUMMARY_MAX_LENGTH) {
          hasExceededLength = true
          fieldValue = fieldValue.slice(0, SUMMARY_MAX_LENGTH)
        }
      }

      const newState = getNewFormValueByInput(prevState, fieldValue)
      checkFieldValidity(newState, hasExceededLength)

      dispatch(updateCertDetailsFormValues(newState))
      return newState
    })

    if (onFieldChange) {
      onFieldChange(
        fieldType === 'list'
          ? dropdownWithSearch.find(item => item.code === e.value) // throw original source from dropdown
          : e
      )
    }
  }

  const handleBeforeInput = e => {
    if (field.attribute_unique_name !== attributeNames.CERTIFICATE_SUMMARY_OF_MODIFICATIONS) {
      return
    }

    const input = e.target
    const value = input.value ?? ''

    const selectionLength = input.selectionEnd - input.selectionStart

    const incomingTextLength = e.data?.length ?? 0

    const nextLength = value.length - selectionLength + incomingTextLength

    if (value.length >= SUMMARY_MAX_LENGTH && nextLength > SUMMARY_MAX_LENGTH) {
      e.preventDefault()

      setFormValues(prevState => {
        const newState = { ...prevState }

        checkFieldValidity(newState, true)

        return prevState
      })
    }
  }

  const getNewFormValueByInput = (prevFormValuesState, input) => {
    var newFormValuesState = JSON.parse(JSON.stringify(prevFormValuesState))
    const newInput = input
    switch (fieldType) {
      case 'list':
        if (newFormValuesState[field.attribute_unique_name].length > 0) {
          newFormValuesState[field.attribute_unique_name][fieldIndex] = newInput
        } else {
          newFormValuesState[field.attribute_unique_name] = [newInput]
        }
        break
      case 'table':
        if (newFormValuesState[field.attribute_unique_name].length > 0) {
          if (Array.isArray(newFormValuesState[field.attribute_unique_name])) {
            newFormValuesState[field.attribute_unique_name][rowIndex] = newInput
          } else {
            newFormValuesState[field.attribute_unique_name] = newInput
          }
        } else {
          newFormValuesState[field.attribute_unique_name] = [newInput]
        }
        break
      default:
        newFormValuesState[field.attribute_unique_name] = newInput
        break
    }

    return newFormValuesState
  }

  const isDisableTextField = fieldName => {
    if (
      fieldName === getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName') &&
      ((isEditCert && (hasRevisions || isModifyCert)) || isAutoGenerate)
    )
      return true
    return false
  }

  const debouncedFilterDropdownWithSearch = useCallback(
    debounce(onFilterDropdownWithSearch, 1000),
    []
  )

  const isDisableSingleSelect = fieldName => {
    if (
      fieldName === getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateType') &&
      isEditCert
    )
      return true
    return false
  }

  const isDisableSingleSelectWithSearch = fieldName => {
    if (
      fieldName === getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference') &&
      (isEditCert || copyState?.models)
    )
      return true
    return false
  }

  const isDisableDatePicker = fieldName => {
    const isDisable = fieldName === attributeNames.ISSUE_DATE && hasOriginalIssueDate

    if (isDisable && isEditCert && (hasRevisions || isModifyCert)) return true
    return false
  }

  const dateTooltipHelper = selectedDate => {
    const formattedDate = selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : null
    return formattedDate
  }

  const hasEnteredNotApplicable = text => {
    const notApplicableValues = ['N/A', 'NA', 'NOTAPPLICABLE']

    // Remove all spaces from input
    text = text?.replace(/ /g, '')

    return notApplicableValues.includes(text?.toUpperCase())
  }

  const enteredNotApplicableErrorMessage = 'N/A or Not Applicable are not valid values.'

  const isCertificateNameField = field => {
    return field.attribute_unique_name === 'certificateName'
  }

  const isFormValuesObjectInValid = formValuesObject => {
    return formValuesObject && Object.keys(formValuesObject).length == 0
  }

  const constructTooltipForSelectedValues = (
    options,
    dynamicFieldValue,
    optionLabel,
    optionValue
  ) => {
    return (
      options
        ?.filter(option => dynamicFieldValue?.includes(option[optionValue]))
        ?.map(option => option[optionLabel])
        ?.join(' \n') || ''
    )
  }

  const fieldRange = {
    increment: numeral(field?.range_increment).value() ?? undefined,
    low: numeral(field?.range_low).value() ?? undefined,
    high: numeral(field?.range_high).value() ?? undefined,
  }

  /**
   *
   * @param {import("primereact/inputnumber").InputNumberChangeParams} event
   */
  const onDecimalChange = event => {
    if (
      event.originalEvent.type !== 'mousedown' &&
      !['ArrowDown', 'ArrowUp'].includes(event.originalEvent.code)
    ) {
      return onChangeDynamicInput(event.originalEvent)
    }

    let value = event.value
    if (value < fieldRange.low && Boolean(fieldRange.low)) {
      value = fieldRange.low
      setDynamicFieldValue(fieldRange.low)
    } else if (value > fieldRange.high && Boolean(fieldRange.high)) {
      value = fieldRange.high
      setDynamicFieldValue(fieldRange.high)
    }

    return onChangeDynamicInput({
      ...event.originalEvent,
      target: {
        ...event.originalEvent,
        value: value.toString(),
      },
    })
  }

  const itemTemplate = item => {
    if (Boolean(item.emptyTemplate))
      return <span className="empty-item-template">{item.emptyTemplate}</span>
    const content = typeof item === 'string' ? item : item.name
    return (
      <div title={content} className="text-container-ellipsis">
        {content}
      </div>
    )
  }

  const calendarId = `dynamic-calendar-${field.id}-${rowIndex}`

  const certifyDisabledField =
    !recommendationStatus && listCertifyAttributes.includes(field.attribute_unique_name)

  const coDecisionDisabledField =
    skipCoDecisioning && listDecisionAttributes.includes(field.attribute_unique_name)

  const disabledFields = certifyDisabledField || coDecisionDisabledField
  if (field.attribute_unique_name === attributeNames.WATER_EFFICIENCY_RATING) {
    field.list_values = field.list_values.length > 0 ? field.list_values : field.scale
  }

  const getStandardOptions = () => {
    if ((isModifyCert || isEditCert) && field.attribute_unique_name === attributeNames.STANDARD) {
      return temporaryStandardOptions
    }

    if (
      (isModifyCert || isEditCert) &&
      field.attribute_unique_name === attributeNames.SECONDARY_STANDARD
    ) {
      return tempSecondaryStandardOptions
    }

    return standardOptions
  }

  const applyUniqueValidityMessage = () => {
    if (!Boolean(field.is_allow_search)) return

    const maxValue = numeral(field.max_value).value()
    if (maxValue <= 0 && field.max_value !== 'n') return

    const rawValue = formValues[field.attribute_unique_name]
    if (!Array.isArray(rawValue)) return
    const rawValueTrimmed = rawValue.filter(Boolean)

    setFormValidityMessages(prev => {
      const next = {
        ...prev,
      }

      next[field.attribute_unique_name] =
        rawValueTrimmed.length === new Set(rawValueTrimmed).size
          ? ''
          : {
            value: `${getRenamedPanels(field.display_level_text)} already exists`,
            displayOnEffect: true,
          }

      return next
    })
  }

  useEffect(() => {
    applyUniqueValidityMessage()
  }, [formValues])

  useEffect(async () => {
    if (filterListener?.value && filterListener.field === field.attribute_unique_name) {
      //CHECKING INDEX OF TARGET LIST VALUE
      if (typeof filterListener?.index === 'number' && filterListener?.index !== fieldIndex) return
      const uuid = field.uuid ?? `row-${fieldIndex}`
      setisIpAttributesDropdownListLoading(true)

      await CertificateListService.getIpAttributesDropdownList(
        field.attribute_name,
        filterListener.value
      ).then(result => {
        if (result) {
          setDropdownWithSearch(result)
          const currentValue = result.find(x => x.code === filterListener.value)

          let newValue = currentValue.code

          if (setCacheValues) {
            setCacheValues(prev => ({
              ...prev,
              [uuid]: currentValue,
            }))
          }

          setFormValues(prevState => {
            if (Array.isArray(prevState[filterListener.field])) {
              newValue = structuredClone(prevState[filterListener.field])

              if (newValue.length > 0) {
                newValue[filterListener.index] = currentValue.code
              } else newValue = [currentValue.code]
            }

            const newState = {
              ...prevState,
              [filterListener.field]: newValue,
            }

            checkFieldValidity(newState)

            dispatch(updateCertDetailsFormValues(newState))
            return newState
          })
        }

        setFilterListener({
          field: null,
          value: null,
          index: null,
        })

        setisIpAttributesDropdownListLoading(false)
      })
    }
  }, [filterListener])

  const showClear =
    !readOnly &&
    Boolean(dynamicFieldValue) &&
    field.attribute_unique_name !==
    getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateType')

  const secondaryPlaceholder =
    (standardValue ?? []).length <= 0 &&
    field.attribute_unique_name ===
    getAttributeUniqueName(CertificateGroupEnum.Certificate, 'secondaryStandard') &&
    (standardOptions ?? []).length <= 0 &&
    Boolean(selectedProductTypeCode) &&
    (isEditCert || isModifyCert) &&
    ''

  const dropdownSuggestion = e => {
    const query = e.query?.toLowerCase() || ''

    if (!query.trim()) {
      setFiltered([...field.list_values])
      return
    }

    const filtered = field?.list_values?.filter(list => list.toLowerCase().includes(query))

    setFiltered(filtered)
  }

  const handleTextareaInput = e => {
    const el = e.target
    const shouldScroll = el.scrollHeight > 120
    setIsTextAreaScrollable(shouldScroll)
  }

  const isListValues =
    field.list_values && Array.isArray(field.list_values) && field.list_values.length > 0

  return (
    <div>
      {isListValues && !isDynamicInputField && (
        <div>
          {(fieldType === 'list' || fieldType === 'table') && (
            <ToolTipField
              fieldName={field.attribute_unique_name}
              index={rowIndex}
              value={dynamicFieldValue}
            >
              <Dropdown
                value={dynamicFieldValue}
                options={field.list_values}
                onChange={onChangeDynamicInput}
                panelClassName="ellipsis-panel"
                itemTemplate={itemTemplate}
                className={clsx({
                  disabled: disabledFields,
                })}
                showClear={showClear}
                appendTo={'self'}
              />
            </ToolTipField>
          )}
          {fieldType === 'single' && (
            <ToolTipField
              fieldName={field.attribute_unique_name}
              index={rowIndex}
              value={dynamicFieldValue}
            >
              <Dropdown
                appendTo={'self'}
                value={dynamicFieldValue}
                options={field.list_values}
                onChange={onChangeDynamicInput}
                disabled={isDisableSingleSelect(field.attribute_unique_name)}
                panelClassName="ellipsis-panel"
                itemTemplate={itemTemplate}
                className={clsx({
                  disabled: disabledFields,
                })}
                showClear={showClear}
              />
            </ToolTipField>
          )}
          {fieldType === 'selectmultiple' && (
            <ToolTipField
              fieldName={field.attribute_unique_name}
              index={rowIndex}
              value={dynamicFieldValue}
            >
              <MultiSelect
                className={clsx('dynamic-field-multiselect', {
                  disabled: disabledFields,
                })}
                disabled={isDisabled}
                options={field.list_values}
                value={dynamicFieldValue}
                onChange={onChangeDynamicInput}
                panelClassName="ellipsis-panel"
                appendTo={'self'}
              />
            </ToolTipField>
          )}
        </div>
      )}

      {(isListValues || isProjectHandlerOrReviewerField) && isDynamicInputField && (
        <div className="dynamic-autocomplete-div">
          {isProjectHandlerOrReviewerField && (
            <ToolTipField
              fieldName={field.attribute_unique_name}
              index={rowIndex ?? fieldIndex}
              value={dynamicFieldValue}
            >
              <UsersAutoComplete
                value={dynamicFieldValue}
                onChange={onChangeDynamicInput}
                className={clsx({
                  disabled: disabledFields,
                  'input-semicolon-validation-outline': Boolean(fieldValidityMessage),
                })}
                dropdown
                appendTo={'self'}
                source="azure-ad"
              />
              {fieldValidityMessage && (
                <div className="summary-validation-message semicolon-validation-color">
                  {fieldValidityMessage}
                </div>
              )}
            </ToolTipField>
          )}

          {!isProjectHandlerOrReviewerField && (fieldType === 'list' || fieldType === 'table') && (
            <ToolTipField
              fieldName={field.attribute_unique_name}
              index={rowIndex ?? fieldIndex}
              value={dynamicFieldValue}
            >
              <AutoComplete
                value={dynamicFieldValue}
                suggestions={filtered}
                completeMethod={dropdownSuggestion}
                onChange={onChangeDynamicInput}
                className={clsx({
                  disabled: disabledFields,
                  'input-semicolon-validation-outline': Boolean(fieldValidityMessage),
                })}
                dropdown
                appendTo={'self'}
              />
              {fieldValidityMessage && (
                <div className="summary-validation-message semicolon-validation-color">
                  {fieldValidityMessage}
                </div>
              )}
            </ToolTipField>
          )}

          {!isProjectHandlerOrReviewerField && fieldType === 'single' && (
            <ToolTipField
              fieldName={field.attribute_unique_name}
              index={rowIndex ?? fieldIndex}
              value={dynamicFieldValue}
            >
              <AutoComplete
                value={dynamicFieldValue}
                suggestions={filtered}
                completeMethod={dropdownSuggestion}
                onChange={onChangeDynamicInput}
                className={clsx(
                  {
                    disabled: disabledFields,
                    'input-semicolon-validation-outline': Boolean(fieldValidityMessage),
                  },
                  'single-autocomplete'
                )}
                dropdown
                disabled={isDisableSingleSelect(field.attribute_unique_name)}
                appendTo={'self'}
              />
              {fieldValidityMessage && (
                <div className="summary-validation-message semicolon-validation-color">
                  {fieldValidityMessage}
                </div>
              )}
            </ToolTipField>
          )}
        </div>
      )}

      {field.list_values.length === 0 && !isDynamicInputField && (
        <>
          {field.data_type.toLowerCase() === 'date' && (
            <div className="dynamic-field-date-div">
              <Tooltip
                target={`#${calendarId}`}
                content={dateTooltipHelper(selectedDate)}
                position="bottom"
                showOnDisabled={true}
              />

              <CustomDatePicker
                dateFormat="yyyy-MM-dd"
                className={clsx('dynamic-field-date dynamic-field-date-picker-' + field.id, {
                  disabled: disabledFields,
                })}
                selected={selectedDate}
                onChange={date => onChangeDate(date)}
                disabled={isDisableDatePicker(field.attribute_unique_name)}
                placeholderText="YYYY-MM-DD"
                id={calendarId}
              />
              <label
                htmlFor={calendarId}
                className={clsx({
                  disabled: disabledFields,
                })}
              >
                <FontAwesomeIcon icon={faCalendarDay} />
              </label>
            </div>
          )}
          {field.data_type.toLowerCase() === 'integer' && (
            <>
              <ToolTipField
                fieldName={field.attribute_unique_name}
                index={rowIndex ?? fieldIndex}
                value={dynamicFieldValue}
              >
                <ControlledInput
                  value={dynamicFieldValue}
                  onChange={onChangeDynamicInput}
                  disabled={isDisableTextField(field.attribute_unique_name)}
                  InputComponent={InputText}
                  keyfilter={'int'}
                  className={clsx({
                    disabled: disabledFields,
                  })}
                />
              </ToolTipField>
            </>
          )}
          {field.data_type.toLowerCase() === 'decimal' && (
            <>
              <div>
                <ToolTipField
                  fieldName={field.attribute_unique_name}
                  index={rowIndex}
                  value={dynamicFieldValue}
                >
                  <InputNumber
                    value={Boolean(dynamicFieldValue) ? dynamicFieldValue : null}
                    allowEmpty
                    useGrouping={false}
                    onChange={onDecimalChange}
                    disabled={isDisableTextField(field.attribute_unique_name)}
                    className={clsx({
                      disabled: disabledFields,
                    })}
                    style={{
                      width: '100%',
                    }}
                    showButtons
                    incrementButtonClassName={clsx(
                      'p-button-outlined p-button-secondary',
                      dynamicFieldValue >= fieldRange.high && 'disabled'
                    )}
                    decrementButtonClassName={clsx(
                      'p-button-outlined p-button-secondary',
                      dynamicFieldValue <= fieldRange.low && 'disabled'
                    )}
                    step={fieldRange.increment}
                    maxFractionDigits={
                      !fieldRange.increment ? undefined : countDecimals(fieldRange.increment)
                    }
                  />
                </ToolTipField>
              </div>
            </>
          )}
          {field.data_type.toLowerCase() === 'text' && (
            <>
              {/* LIST SELECT WITH SEARCH */}
              {fieldType === 'list' && field.is_allow_search && (
                <ToolTipField
                  fieldName={field.attribute_unique_name}
                  index={rowIndex}
                  value={constructTooltipForSelectedValues(
                    dropdownWithSearch,
                    dynamicFieldValue,
                    'name',
                    'code'
                  )}
                >
                  <Dropdown
                    appendTo={'self'}
                    emptyFilterMessage={
                      isIpAttributesDropdownListLoading ? 'Loading...' : 'No results found'
                    }
                    emptyMessage={
                      isIpAttributesDropdownListLoading ? 'Loading...' : 'No results found'
                    }
                    dropdownIcon={
                      isIpAttributesDropdownListLoading
                        ? 'pi pi-spin pi-spinner'
                        : 'pi pi-chevron-down'
                    }
                    panelClassName="dynamic-field-dropdown-panel ellipsis-panel"
                    value={dynamicFieldValue}
                    optionDisabled={item => Boolean(item.emptyTemplate)}
                    options={
                      (dropdownWithSearch ?? []).length > 0
                        ? dropdownWithSearch
                        : [
                          {
                            emptyTemplate: 'No results found',
                          },
                        ] // currently primereact doesnt allow filter when array is empty
                    }
                    optionLabel="name"
                    optionValue="code"
                    filter
                    panelStyle={{ width: '200px' }}
                    onFilter={e => {
                      setisIpAttributesDropdownListLoading(true)
                      setFilterTextValue(e.filter)
                      debouncedFilterDropdownWithSearch(e)
                    }}
                    filterTextValue={filterTextValue}
                    onChange={onChangeDynamicInput}
                    itemTemplate={itemTemplate}
                    className={clsx({
                      disabled: disabledFields,
                      'read-only': readOnly,
                    })}
                    valueTemplate={
                      Boolean(listCacheValue) ? (
                        <span className="list-cache-value">{listCacheValue.name}</span>
                      ) : undefined
                    }
                    showClear={Boolean(listCacheValue) && showClear}
                  />
                </ToolTipField>
              )}
              {(fieldType === 'list' || fieldType === 'table') && !field.is_allow_search && (
                <ToolTipField
                  fieldName={field.attribute_unique_name}
                  index={rowIndex ?? fieldIndex}
                  value={dynamicFieldValue}
                >
                  <ControlledInput
                    value={dynamicFieldValue}
                    onChange={onChangeDynamicInput}
                    InputComponent={InputText}
                    className={clsx({
                      disabled: disabledFields,
                      'input-validation-outline': Boolean(summaryValidityMessage),
                      'input-semicolon-validation-outline': Boolean(fieldValidityMessage),
                    })}
                    onBeforeInput={handleBeforeInput}
                  />
                  {summaryValidityMessage && (
                    <div className="summary-validation-message validation-color">
                      {summaryValidityMessage}
                    </div>
                  )}
                  {fieldValidityMessage && (
                    <div className="summary-validation-message semicolon-validation-color">
                      {fieldValidityMessage}
                    </div>
                  )}
                </ToolTipField>
              )}
              {(fieldType === 'single' || fieldType === 'selectmultiple') && (
                <>
                  {field.is_allow_search &&
                    field.is_select_multiple &&
                    !field.is_search &&
                    (() => {
                      return (
                        <>
                          <ToolTipField
                            fieldName={field.attribute_unique_name}
                            index={rowIndex}
                            value={dynamicFieldValue}
                          >
                            <MultiSelect
                              className={clsx('dynamic-field-multiselect', {
                                disabled: disabledFields,
                              })}
                              value={
                                Array.isArray(dynamicFieldValue)
                                  ? dynamicFieldValue
                                  : [dynamicFieldValue]
                              }
                              options={dropdownWithSearch}
                              optionLabel="name"
                              optionValue="code"
                              filter
                              onFilter={onFilterDropdownWithSearch}
                              onChange={onChangeDynamicInput}
                              disabled={isDisableSingleSelectWithSearch(
                                field.attribute_unique_name
                              )}
                              panelClassName="ellipsis-panel"
                              appendTo={'self'}
                            />
                          </ToolTipField>
                        </>
                      )
                    })()}

                  {field.is_select_multiple && !field.is_allow_search && (
                    <>
                      <ToolTipField
                        fieldName={field.attribute_unique_name}
                        index={rowIndex}
                        value={
                          showMultiSelectValuesTooltip
                            ? constructTooltipForSelectedValues(
                              standardOptions,
                              standardValue,
                              'name',
                              'code'
                            )
                            : ''
                        }
                      >
                        <MultiSelect
                          className={clsx('dynamic-field-multiselect', {
                            disabled: disabledFields,
                          })}
                          filter
                          disabled={isDisabled || isFieldDisabled || standardOptions?.length == 0}
                          value={standardValue}
                          options={getStandardOptions()}
                          optionLabel="name"
                          optionValue="code"
                          onChange={onChangeDynamicInput}
                          placeholder={secondaryPlaceholder ?? standardPlaceholder}
                          panelClassName="ellipsis-panel"
                          appendTo={'self'}
                        />
                      </ToolTipField>
                    </>
                  )}
                  {!field.is_search && !field.is_allow_search && !field.is_select_multiple && (
                    <>
                      <ToolTipField
                        fieldName={field.attribute_unique_name}
                        index={rowIndex ?? fieldIndex}
                        value={
                          isCertificateNameField(field) &&
                            hasEnteredNotApplicable(dynamicFieldValue)
                            ? enteredNotApplicableErrorMessage
                            : dynamicFieldValue
                        }
                      >
                        <ControlledInput
                          value={dynamicFieldValue}
                          onChange={onChangeDynamicInput}
                          // For certificate number/certificateName field,
                          // show tooltip error message if the input entered is 'Not Applicable',
                          // otherwise show the help text message.
                          disabled={isDisableTextField(field.attribute_unique_name)}
                          InputComponent={InputText}
                          maxLength={isCertificateNameField(field) ? 150 : 1000}
                          className={clsx({
                            disabled: disabledFields,
                            'input-semicolon-validation-outline': Boolean(fieldValidityMessage),
                          })}
                        />
                        {fieldValidityMessage && (
                          <div className="summary-validation-message semicolon-validation-color">
                            {fieldValidityMessage}
                          </div>
                        )}
                      </ToolTipField>
                    </>
                  )}
                  {field.is_search && !field.is_allow_search && (
                    <>
                      <ToolTipField
                        fieldName={field.attribute_unique_name}
                        index={rowIndex}
                        value={constructTooltipForSelectedValues(
                          dropdownWithSearch,
                          dynamicFieldValue,
                          'name',
                          'code'
                        )}
                      >
                        <Dropdown
                          appendTo={'self'}
                          value={dynamicFieldValue}
                          options={dropdownWithSearch}
                          optionLabel="name"
                          optionValue="code"
                          onChange={onChangeDynamicInput}
                          panelClassName="ellipsis-panel"
                          itemTemplate={itemTemplate}
                          className={clsx({
                            disabled: disabledFields,
                          })}
                          showClear={showClear}
                        />
                      </ToolTipField>
                    </>
                  )}

                  {/* SINGLE SELECTION WITH SEARCH */}
                  {field.is_allow_search && !field.is_search && !field.is_select_multiple && (
                    <>
                      <ToolTipField
                        fieldName={field.attribute_unique_name}
                        index={rowIndex}
                        value={constructTooltipForSelectedValues(
                          dropdownWithSearch,
                          dynamicFieldValue,
                          'name',
                          'code'
                        )}
                      >
                        <Dropdown
                          appendTo={'self'}
                          emptyFilterMessage={
                            isIpAttributesDropdownListLoading ? 'Loading...' : 'No results found'
                          }
                          ref={dropdownRef}
                          panelClassName="dynamic-field-dropdown-panel ellipsis-panel"
                          value={dynamicFieldValue}
                          options={dropdownWithSearch}
                          optionLabel="name"
                          optionValue="code"
                          filter
                          panelStyle={{ width: '200px' }}
                          onFilter={e => {
                            setisIpAttributesDropdownListLoading(true)
                            setFilterTextValue(e.filter)
                            debouncedFilterDropdownWithSearch(e)
                          }}
                          filterTextValue={filterTextValue}
                          dropdownIcon={
                            isIpAttributesDropdownListLoading
                              ? 'pi pi-spin pi-spinner'
                              : 'pi pi-chevron-down'
                          }
                          onChange={onChangeDynamicInput}
                          disabled={isDisableSingleSelectWithSearch(field.attribute_unique_name)}
                          itemTemplate={itemTemplate}
                          className={clsx({
                            disabled: disabledFields,
                          })}
                          showClear={showClear}
                        />
                      </ToolTipField>
                    </>
                  )}
                </>
              )}
            </>
          )}
          {field.data_type.toLowerCase() === 'textarea' && (
            <>
              <ToolTipField
                fieldName={field.attribute_unique_name}
                index={rowIndex ?? fieldIndex}
                value={
                  fieldType === 'list' || fieldType === 'table'
                    ? formValues[field.attribute_unique_name][fieldIndex]
                    : formValues[field.attribute_unique_name]
                }
              >
                <ControlledInput
                  InputComponent={InputTextarea}
                  value={
                    fieldType === 'list' || fieldType === 'table'
                      ? formValues[field.attribute_unique_name][fieldIndex]
                      : formValues[field.attribute_unique_name]
                  }
                  onChange={onChangeDynamicInput}
                  id={field.attribute_unique_name}
                  ref={textareaRef}
                  onInput={handleTextareaInput}
                  rows={1}
                  autoResize
                  cols={30}
                  className={clsx(
                    {
                      disabled: disabledFields,
                      'input-semicolon-validation-outline': Boolean(fieldValidityMessage),
                    },
                    'textarea-input',
                    isTextAreaScrollable ? 'textarea-input-scroll' : ''
                  )}
                />
                {fieldValidityMessage && (
                  <div className="summary-validation-message semicolon-validation-color">
                    {fieldValidityMessage}
                  </div>
                )}
              </ToolTipField>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default DynamicFieldMultiple
